import { render, staticRenderFns } from "./o-contact-leads-v2.vue?vue&type=template&id=358c0054&scoped=true"
import script from "./o-contact-leads-v2.vue?vue&type=script&lang=js"
export * from "./o-contact-leads-v2.vue?vue&type=script&lang=js"
import style0 from "./o-contact-leads-v2.vue?vue&type=style&index=0&id=358c0054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358c0054",
  null
  
)

export default component.exports